// extracted by mini-css-extract-plugin
export default {"groupList":"GroupsPage_groupList__tI6m9"};